import { detail } from "@mc/mc-legacy";
export const LOGOUT_STATUS = "logoutStatus";
export function setUserLogout() {
  return (dispatch) => {
    dispatch(detail.DetailActions.setData(LOGOUT_STATUS, 'a', {userLogout: true}));
  };
}
export function invalidate() {
  return (dispatch) => {
    dispatch(detail.DetailActions.invalidate(LOGOUT_STATUS, 0));
  };
}
